import { ReactNode } from "react"
import { cn } from "~/common/cn"
import { AppText } from "~/ui/app-text"

interface EpisodeCardEpisode {
  title: string
  thumbnailUrl?: string | null
  source?: { name: string; logoUrl?: string | null } | null
}

interface Props {
  episode: EpisodeCardEpisode
  footer?: ReactNode
  className?: string
}

export const EpisodeCard: React.FC<Props> = ({ episode, footer, className }) => (
  <div className={cn("flex flex-col gap-3 rounded-lg bg-base-black p-4", className)}>
    <div className="flex flex-row items-center gap-3">
      {episode.source?.logoUrl && (
        <img
          src={episode.source.logoUrl}
          alt={episode.source.name}
          className="h-[52px] w-[52px] flex-shrink-0 rounded-lg object-cover"
        />
      )}
      <div className="flex min-w-0 flex-col">
        <AppText variant="h3" className="line-clamp-2 text-base-white">
          {episode.title}
        </AppText>
        {episode.source?.name && (
          <AppText variant="caption" className="line-clamp-1 text-neutral-400">
            {episode.source.name}
          </AppText>
        )}
      </div>
    </div>

    {episode.thumbnailUrl && (
      <div className="relative aspect-video overflow-hidden rounded">
        <img
          src={episode.thumbnailUrl}
          alt={episode.title}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/90">
            <div className="ml-1 h-0 w-0 border-b-[9px] border-l-[15px] border-t-[9px] border-b-transparent border-l-black border-t-transparent" />
          </div>
        </div>
      </div>
    )}

    {footer}
  </div>
)
